import { Swiper, SwiperSlide } from "swiper/react";
import { Col, Container, Row } from 'react-bootstrap';
import img1 from "../../img/dots-1.png"
import React from "react";
import tpic1 from "../../img/team-7-300x300-1.png"
import tpic2 from "../../img/team-8-300x300-1.png"
// Import Swiper React components
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination"
// import Swiper core and required modules
import SwiperCore, {
    Pagination, Autoplay
} from 'swiper';
// install Swiper modules
SwiperCore.use([Pagination, Autoplay]);
const Testimonal = () => {
    const arrayTes = [
        {
            id: 1,
            name: "Md Apon Deawan",
            title: "CEO AS Team",
            img: tpic1,
            des: "We are motivated by the satisfaction of our clients. Put your trust in us and share in our growth Asset Management is made up of a team of expert, committed and experienced people with a passion for financial markets. Our goal is to achieve continuous."

        },
        {
            id: 2,
            name: "Md Kamrul Islam",
            title: "CEO ABC Company",
            img: tpic2,
            des: "We are motivated by the satisfaction of our clients. Put your trust in us and share in our growth Asset Management is made up of a team of expert, committed and experienced people with a passion for financial markets. Our goal is to achieve continuous."
        },
        {
            id: 3,
            name: "Md Apon Deawan",
            title: "CEO AS Team",
            img: tpic1,
            des: "We are motivated by the satisfaction of our clients. Put your trust in us and share in our growth Asset Management is made up of a team of expert, committed and experienced people with a passion for financial markets. Our goal is to achieve continuous."

        },
    ]
    return (
        <Container className="mt-5 pb-5">
            <Row>
                <Col>
                    <div className="project-title text-white">
                        <p>TESTIMONIALS</p>
                        <h3>Happy Clients Says</h3>
                        <img className='img-fluid' src={img1} alt="" />
                    </div>
                </Col>
            </Row>
            <Row>
                <Swiper slidesPerView={2} spaceBetween={30} breakpoints={{
                "0": {
                  "slidesPerView": 1,
                  "spaceBetween": 20
                },
                "992": {
                  "slidesPerView": 2,
                  "spaceBetween": 40
                },
                "1224": {
                  "slidesPerView": 2,
                  "spaceBetween": 50
                }
              }} autoplay={{
                    delay: 4000
                }} loop={true}
                    pagination={{
                        "clickable": true
                    }} className="mySwiper">
                    {arrayTes.map(item => (
                        <SwiperSlide>
                            <div className="test py-4 px-5  text-white">
                                <div className="tittle-test d-flex align-items-center">
                                    <img src={item.img} alt="" />
                                    <div className="img-test">
                                        <p>{item.name}</p>
                                        <p>{item.title}</p>
                                    </div>
                                </div>
                                <p>{item.des}</p>
                            </div>
                        </SwiperSlide>
                    ))

                    }
                </Swiper>
            </Row>
        </Container>
    );
};

export default Testimonal;